export default {
  online: state => state.online,
  sidebarOpen: state => state.sidebarOpen,
  version: state => state.version,
  authenticated: state => state.authenticated,
  profileComplete: state => state.profileComplete,
  loading: state => state.loading,
};
